import type { QueryClient } from '@tanstack/react-query';
import type { SellerSupportMessage, SellerSupportMessagesResponse } from './types';

export const SELLER_CHAT_MESSAGES_QUERY_KEY = ['seller-support-chat', 'messages'] as const;
export const SELLER_CHAT_UNREAD_QUERY_KEY = ['seller-support-chat', 'unread-count'] as const;

export function mergeSellerSupportMessages(
  prev: SellerSupportMessagesResponse | undefined,
  next: SellerSupportMessagesResponse,
): SellerSupportMessagesResponse {
  if (!prev?.items.length) return next;
  const byId = new Map(prev.items.map((item) => [item.id, item]));
  for (const item of next.items) byId.set(item.id, item);
  const items = [...byId.values()].sort((a, b) => {
    const byTime = new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime();
    return byTime !== 0 ? byTime : a.id - b.id;
  });
  return {
    threadId: next.threadId || prev.threadId,
    items,
    total: Math.max(next.total, items.length),
  };
}

export function appendSellerSupportMessageToCache(
  queryClient: QueryClient,
  message: SellerSupportMessage,
) {
  queryClient.setQueryData<SellerSupportMessagesResponse>(
    SELLER_CHAT_MESSAGES_QUERY_KEY,
    (prev) => {
      const base = prev ?? { items: [], total: 0, threadId: message.threadId };
      if (base.items.some((item) => item.id === message.id)) return base;
      return {
        ...base,
        threadId: message.threadId || base.threadId,
        items: [...base.items, message],
        total: base.total + 1,
      };
    },
  );
}
